export default "__VITE_ASSET__DZdWi4dL__"